module.exports = __webpack_public_path__ + "img/关注公众号.13369f79.png";